export const endPoints = {
    businessList: '/api/Businesses/list',
    businessListContacts: '/api/Businesses/listAllBusinessContacts',
    businessById: '/api/Businesses/',
    businessDetails: '/api/Businesses',
    addBusiness: '/api/Businesses/new',
    purgeBusinesses: '/api/Businesses/purgeSelectedBusinesses',
    deactivateBusinesses: '/api/Businesses/toggleSelectedBusinesses',

    businessAddressesByBusinessId: '/api/BusinessAddresses/forBusiness',
    businessAddressesByAddressId: '/api/BusinessAddresses/forAddress',
    businessGroupsByBusinessId: '/api/Businesses/listGroupSubscriptionForBusiness?businessID=',
    updateBusinessAddress: '/api/BusinessAddresses/update',
    addBusinessAddress: '/api/BusinessAddresses/add',
    deleteBusinessAddress: '/api/BusinessAddresses',
    purgeSelectedAddresses: '/api/BusinessAddresses/purgeSelectedAddresses',
    deactivateSelectedAddresses: '/api/BusinessAddresses/toggleSelectedAddressStatus',

    businessContactsByBusinessId: '/api/BusinessContacts/forBusiness',
    subscriptionsBySubId: '/api/BusinessContacts/bySubscriptionId',
    subscriptionsByContactId: '/api/BusinessContacts/subscriptionForContact',
    addBusinessContact: '/api/BusinessContacts/add',
    updateContact: '/api/BusinessContacts/update',
    getBusinessContact: '/api/BusinessContacts/{id}',
    deleteBusinessContact: '/api/BusinessContacts',
    addSubscriptionToBusinessContact: '/api/BusinessContacts/subscribe',
    removeSubscriptionToBusinessContact: '/api/BusinessContacts/unsubscribe',
    purgeSelectedContacts: '/api/BusinessContacts/purgeSelectedContacts',
    deactivateSelectedContacts: '/api/BusinessContacts/toggleSelectedContactsStatus',

    businessTypes: '/api/BusinessTypes',
    addBusinessType: '/api/BusinessTypes',
    editBusinessType: '/api/BusinessTypes',
    getBusinessTypeById: '/api/BusinessTypes',
    deleteBusinessTypeById: '/api/BusinessTypes',

    communityTypes: '/api/CommunityTypes',
    addCommunityType: '/api/CommunityTypes',
    editCommunityType: '/api/CommunityTypes',
    getCommunityTypeById: '/api/CommunityTypes',
    deleteCommunityTypeById: '/api/CommunityTypes',

    mailingTypes: '/api/MailingListTypes',
    addMailingTypes: '/api/MailingListTypes',
    editMailingTypes: '/api/MailingListTypes',
    getMailingTypeById: '/api/MailingListTypes',
    deleteMailingTypeById: '/api/MailingListTypes',
    

    verify: '/api/Verify',
    isAuthorized: '/api/Verify/isAuthorized?',
    isFullAccess: '/api/Verify/isFullAccess?',
    search: '/api/Businesses/search?searchString=',
    searchStartsWith: '/api/Businesses/searchStartsWith?searchString=',
    searchEndsWith: '/api/Businesses/searchEndsWith?searchString=',

    countMailingList: '/api/Search/countMailingListInUse',
    countBusinessList: '/api/Search/countBusinessTypeInUse',
    countCommunityList: '/api/Search/countCommunityTypeInUse',
    countEOCertifiedList: '/api/Search/countEOCertified',
    countFloodGroupsList: '/api/Search/countFloodGroups',

    searchViaMailingType: '/api/Search/searchBusinessesBySubscription?mailingListTypeID=',
    searchViaCommunityType: '/api/Search/searchBusinessesInCommunity?communityTypeId=',
    searchViaBusinessType: '/api/Search/searchBusinessesByBusinessType?businessTypeID=',
    searchViaEOCertified: '/api/Search/findBusinessesEOCertified',
    searchViaFloodGroups: '/api/Search/findBusinessesInFloodGroups',
    searchBusinessBySubscription: '/api/Search/searchBusinessesBySubscription?mailingListTypeID=',
    exportPdf: '/api/Search/exportPdf?mailListTypeId=',

    usersList: '/api/Verify/listUsers',
    updateUser: '/api/Verify/updateUser',

}